
export default {
  props:{
    alertDesempregado: {
      type: Boolean,
      default: false
    },
    onClose: Function
  }
}
